<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="账号">
              <j-input placeholder="输入账号模糊查询" v-model="queryParam.username"></j-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="真实名字">
              <a-input placeholder="请输入真实名字" v-model="queryParam.realname"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="用户状态">
              <a-select placeholder="请选择" v-model="queryParam.status">
                <a-select-option value>请选择</a-select-option>
                <a-select-option value="1">正常</a-select-option>
                <a-select-option value="2">冻结</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" icon="plus" type="primary">添加用户</a-button>
      <a-button @click="handleExportXls('用户信息')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <j-third-app-button
        :selected-row-keys="selectedRowKeys"
        @sync-finally="onSyncFinally"
        biz-type="user"
        syncToApp
        syncToLocal
      />
      <a-button @click="recycleBinVisible=true" icon="hdd" type="primary">回收站</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu @click="handleMenuClick" slot="overlay">
          <a-menu-item key="1">
            <a-icon @click="batchDel" type="delete" />删除
          </a-menu-item>
          <a-menu-item key="2">
            <a-icon @click="batchFrozen('2')" type="lock" />冻结
          </a-menu-item>
          <a-menu-item key="3">
            <a-icon @click="batchFrozen('1')" type="unlock" />解冻
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
      <j-super-query :fieldList="superQueryFieldList" @handleSuperQuery="handleSuperQuery" />
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项&nbsp;&nbsp;
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange"
        bordered
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar :src="getAvatarView(record.avatar)" icon="user" shape="square" />
          </div>
        </template>

        <template slot="executorExamSlot" slot-scope="text, record, index">
          <a-checkbox :checked="text == '1'" @change="changeExecutor(record, 'executorExam', text)"></a-checkbox>
        </template>

        <template slot="executorDutySlot" slot-scope="text, record, index">
          <a-checkbox :checked="text == '1'" @change="changeExecutor(record, 'executorDuty', text)"></a-checkbox>
        </template>

        <template slot="executorMaintainSlot" slot-scope="text, record, index">
          <a-checkbox :checked="text == '1'" @change="changeExecutor(record, 'executorMaintain', text)"></a-checkbox>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />

          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)" href="javascript:;">详情</a>
              </a-menu-item>

              <a-menu-item>
                <a @click="handleChangePassword(record.username)" href="javascript:;">密码</a>
              </a-menu-item>

              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status==1">
                <a-popconfirm @confirm="() => handleFrozen(record.id,2,record.username)" title="确定冻结吗?">
                  <a>冻结</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status==2">
                <a-popconfirm @confirm="() => handleFrozen(record.id,1,record.username)" title="确定解冻吗?">
                  <a>解冻</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <user-modal @ok="modalFormOk" ref="modalForm"></user-modal>

    <password-modal @ok="passwordModalOk" ref="passwordmodal"></password-modal>

    <sys-user-agent-modal ref="sysUserAgentModal"></sys-user-agent-modal>

    <!-- 用户回收站 -->
    <user-recycle-bin-modal :visible.sync="recycleBinVisible" @ok="modalFormOk" />
  </a-card>
</template>

<script>
  import UserModal from './modules/UserModal'
  import PasswordModal from './modules/PasswordModal'
  import { putAction, getFileAccessHttpUrl } from '@/api/manage';
  import { editUser } from '@/api/api'
  import { frozenBatch } from '@/api/api'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SysUserAgentModal from "./modules/SysUserAgentModal";
  import JInput from '@/components/jeecg/JInput'
  import UserRecycleBinModal from './modules/UserRecycleBinModal'
  import JSuperQuery from '@/components/jeecg/JSuperQuery'
  import JThirdAppButton from '@/components/jeecgbiz/thirdApp/JThirdAppButton'

  export default {
    name: "UserList",
    mixins: [JeecgListMixin],
    components: {
      JThirdAppButton,
      SysUserAgentModal,
      UserModal,
      PasswordModal,
      JInput,
      UserRecycleBinModal,
      JSuperQuery
    },
    data () {
      return {
        description: '这是用户管理页面',
        queryParam: {},
        recycleBinVisible: false,
        ipagination: {
          pageSize: 50,
        },
        columns: [
          {
            title: '用户账号',
            align: "center",
            dataIndex: 'username',
            width: 100,
            sorter: true
          },
          {
            title: '用户姓名',
            align: "center",
            width: 100,
            dataIndex: 'realname',
          },
          {
            title: '头像',
            align: "center",
            width: 120,
            dataIndex: 'avatar',
            scopedSlots: { customRender: "avatarslot" }
          },
          {
            title: '手机号码',
            align: "center",
            width: 100,
            dataIndex: 'phone'
          },
          {
            title: '所属机构',
            align: "center",
            width: 180,
            dataIndex: 'orgCodeTxt'
          },
          //   {
          //     title: '负责部门',
          //     align: "center",
          //     width: 180,
          //     dataIndex: 'departIds_dictText'
          //   },
          {
            title: '值班',
            align: "center",
            dataIndex: 'executorDuty',
            width: 60,
            scopedSlots: { customRender: "executorDutySlot" }
          },
          {
            title: '运维',
            align: "center",
            dataIndex: 'executorMaintain',
            width: 60,
            scopedSlots: { customRender: "executorMaintainSlot" }
          },
          {
            title: '状态',
            align: "center",
            width: 60,
            dataIndex: 'status_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
            align: "center",
            width: 170
          }

        ],
        superQueryFieldList: [
          { type: 'input', value: 'username', text: '用户账号', },
          { type: 'input', value: 'realname', text: '用户姓名', },
          { type: 'select', value: 'sex', dbType: 'int', text: '性别', dictCode: 'sex' },
        ],
        url: {
          syncUser: "/act/process/extActProcess/doSyncUser",
          list: "/sys/user/list",
          edit: "/sys/user/editself",
          delete: "/sys/user/delete",
          deleteBatch: "/sys/user/deleteBatch",
          exportXlsUrl: "/sys/user/exportXls",
          importExcelUrl: "sys/user/importExcel",
        },
      }
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar)
      },

      batchFrozen: function (status) {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！');
          return false;
        } else {
          let ids = "";
          let that = this;
          let isAdmin = false;
          that.selectionRows.forEach(function (row) {
            if (row.username == 'admin') {
              isAdmin = true;
            }
          });
          if (isAdmin) {
            that.$message.warning('管理员账号不允许此操作,请重新选择！');
            return;
          }
          that.selectedRowKeys.forEach(function (val) {
            ids += val + ",";
          });
          that.$confirm({
            title: "确认操作",
            content: "是否" + (status == 1 ? "解冻" : "冻结") + "选中账号?",
            onOk: function () {
              frozenBatch({ ids: ids, status: status }).then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              });
            }
          });
        }
      },
      changeExecutor (user, prop, value) {
        const newVal = 1 ^ parseInt(value, 10);
        user = { id: user.id };
        user[prop] = newVal;
        putAction(this.url.edit, user).then((res) => {
          if (res.success) {
            this.modalFormOk();
          } else {
            this.$message.warning(res.message);
          }
        });
      },
      handleMenuClick (e) {
        if (e.key == 1) {
          this.batchDel();
        } else if (e.key == 2) {
          this.batchFrozen(2);
        } else if (e.key == 3) {
          this.batchFrozen(1);
        }
      },
      handleFrozen: function (id, status, username) {
        let that = this;
        //TODO 后台校验管理员角色
        if ('admin' == username) {
          that.$message.warning('管理员账号不允许此操作！');
          return;
        }
        frozenBatch({ ids: id, status: status }).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      handleChangePassword (username) {
        this.$refs.passwordmodal.show(username);
      },
      passwordModalOk () {
        //TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
      },
      onSyncFinally ({ isToLocal }) {
        // 同步到本地时刷新下数据
        if (isToLocal) {
          this.loadData()
        }
      },
    }

  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>